import { Table } from "antd";

const Table7 = () => {
    const dataSource = [
        {
            key: 1,
            stt: 'Nhóm 1',
            industry: 'Xăng dầu',
            visaVpb: '0.93%',
            visaOtherDomestic: '1.05%',
            masterVpb: '0.93%',
            masterOtherDomestic: '1.05%',
            jcbVpb: '0.93%',
            jcbOtherDomestic: '1.05%',
            uipOtherDomestic: '1.05%',
            foreignCard: '2.80%',
            domesticCard: '0.89%',
        },
        {
            key: 2,
            stt: 'Nhóm 2',
            industry:
                'Điện, Ga, nước. Phí vệ sinh, phí cầu đường. Dịch vụ Công (phí, án phí, thuế...). Dịch vụ vận tải, Giáo dục (Trường học)',
            visaVpb: '1.05%',
            visaOtherDomestic: '1.17%',
            masterVpb: '1.05%',
            masterOtherDomestic: '1.17%',
            jcbVpb: '1.05%',
            jcbOtherDomestic: '1.17%',
            uipOtherDomestic: '1.28%',
            foreignCard: '2.80%',
            domesticCard: '0.89%',
        },
        {
            key: 3,
            stt: 'Nhóm 3',
            industry:
                'Siêu thị. Cửa hàng tiện ích, cửa hàng thực phẩm, thức ăn nhanh, thức uống mang đi. Cước viễn thông/mạng internet',
            visaVpb: '1.05%',
            visaOtherDomestic: '1.17%',
            masterVpb: '1.05%',
            masterOtherDomestic: '1.17%',
            jcbVpb: '1.05%',
            jcbOtherDomestic: '1.17%',
            uipOtherDomestic: '1.17%',
            foreignCard: '2.80%',
            domesticCard: '0.89%',
        },
        {
            key: 4,
            stt: 'Nhóm 4',
            industry: 'Taxi, Limousines',
            visaVpb: '1.28%',
            visaOtherDomestic: '1.40%',
            masterVpb: '1.28%',
            masterOtherDomestic: '1.40%',
            jcbVpb: '1.40%',
            jcbOtherDomestic: '2.45%',
            uipOtherDomestic: '2.33%',
            foreignCard: '2.80%',
            domesticCard: '0.89%',
        },
        {
            key: 5,
            stt: 'Nhóm 5',
            industry:
                'Phòng khám, Y tế. Dịch vụ giáo dục (Trung tâm, ...)',
            visaVpb: '1.52%',
            visaOtherDomestic: '2.45%',
            masterVpb: '1.28%',
            masterOtherDomestic: '2.52%',
            jcbVpb: '1.52%',
            jcbOtherDomestic: '2.45%',
            uipOtherDomestic: '1.52%',
            foreignCard: '2.80%',
            domesticCard: '0.89%',
        },
        {
            key: 6,
            stt: 'Nhóm 6',
            industry: 'Bệnh viện',
            visaVpb: '1.40%',
            visaOtherDomestic: '2.45%',
            masterVpb: '1.40%',
            masterOtherDomestic: '2.45%',
            jcbVpb: '1.40%',
            jcbOtherDomestic: '2.22%',
            uipOtherDomestic: '1.75%',
            foreignCard: '2.80%',
            domesticCard: '0.89%',
        },
        {
            key: 7,
            stt: 'Nhóm 7',
            industry: 'Điện tử, điện máy',
            visaVpb: '1.52%',
            visaOtherDomestic: '1.75%',
            masterVpb: '1.52%',
            masterOtherDomestic: '2.33%',
            jcbVpb: '1.52%',
            jcbOtherDomestic: '2.33%',
            uipOtherDomestic: '2.10%',
            foreignCard: '2.80%',
            domesticCard: '0.89%',
        },
        {
            key: 8,
            stt: 'Nhóm 8',
            industry:
                'Chuỗi cửa hàng ngành mẹ và bé; Du lịch: Thời trang (bán lẻ), Nhà hàng. Khách sạn. Bất động sản. Rạp chiếu phim. Golf; Bán lẻ hóa mỹ phẩm; đá quý, nữ trang, đồng hồ và các nhóm ngành còn lại',
            visaVpb: '1.63%',
            visaOtherDomestic: '2.33%',
            masterVpb: '1.63%',
            masterOtherDomestic: '2.33%',
            jcbVpb: '1.63%',
            jcbOtherDomestic: '2.33%',
            uipOtherDomestic: '2.33%',
            foreignCard: '2.80%',
            domesticCard: '0.89%',
        },
    ];

    const columns = [
        {
            title: 'STT',
            dataIndex: 'stt',
            key: 'stt',
            width: 55,
            align: 'center',
        },
        {
            title: 'Các ngành nghề',
            dataIndex: 'industry',
            key: 'industry',
            width: 200,
        },
        {
            title: 'Thẻ Visa',
            children: [
                {
                    title: <>Thẻ<br />VPB</>,
                    dataIndex: 'visaVpb',
                    key: 'visaVpb',
                    align: 'center',
                    render: (value) => (
                        <span className="text-danger">{value}</span>
                    ),
                },
                {
                    title: <>Ngân hàng khác<br />Phát hành trong nước</>,
                    dataIndex: 'visaOtherDomestic',
                    key: 'visaOtherDomestic',
                    align: 'center',
                    render: (value) => (
                        <span className="text-danger">{value}</span>
                    ),
                },
            ],
        },
        {
            title: 'Thẻ Master',
            children: [
                {
                    title: <>Thẻ<br />VPB</>,
                    dataIndex: 'masterVpb',
                    key: 'masterVpb',
                    align: 'center',
                    render: (value) => (
                        <span className="text-danger">{value}</span>
                    ),
                },
                {
                    title: <>Ngân hàng khác<br />Phát hành trong nước</>,
                    dataIndex: 'masterOtherDomestic',
                    key: 'masterOtherDomestic',
                    align: 'center',
                    render: (value) => (
                        <span className="text-danger">{value}</span>
                    ),
                },
            ],
        },
        {
            title: 'Thẻ JCB',
            children: [
                {
                    title: <>Thẻ<br />VPB</>,
                    dataIndex: 'jcbVpb',
                    key: 'jcbVpb',
                    align: 'center',
                    render: (value) => (
                        <span className="text-danger">{value}</span>
                    ),
                },
                {
                    title: <>Ngân hàng khác<br />Phát hành trong nước</>,
                    dataIndex: 'jcbOtherDomestic',
                    key: 'jcbOtherDomestic',
                    align: 'center',
                    render: (value) => (
                        <span className="text-danger">{value}</span>
                    ),
                },
            ],
        },

        {
            title: 'UIP',
            children: [
                {
                    title: (
                        <>
                            Ngân hàng khác
                            <br />
                            Phát hành trong nước
                        </>
                    ),
                    dataIndex: 'uipOtherDomestic',
                    key: 'uipOtherDomestic',
                    align: 'center',
                    render: (value) => (
                        <span className="text-danger">{value}</span>
                    ),
                }
            ]
        },
        {
            title: (
                <>
                    Thẻ Visa/Master
                    <br />
                    JCB/UIP
                    <br />
                    phát hành nước ngoài
                </>
            ),
            dataIndex: 'foreignCard',
            key: 'foreignCard',
            align: 'center',
            render: (value) => (
                <span className="text-danger">{value}</span>
            ),
        },
        {
            title: (
                <>
                    Thẻ
                    <br />
                    Nội địa
                </>
            ),
            dataIndex: 'domesticCard',
            key: 'domesticCard',
            align: 'center',
            render: (value) => (
                <span className="text-danger">{value}</span>
            ),
        },
    ];
    return (
        <div className="mt-5">
            <h2 className="fw-bold fs-4 mb-3 text-center">BẢNG 7: BIỂU PHÍ POS – áp dụng với khách hàng đại lý (Doanh số từ 100 tỷ trở lên) sử dụng dịch vụ từ ngân hàng VPBank</h2>
            <div>
                <Table
                    bordered
                    pagination={false}
                    dataSource={dataSource}
                    columns={columns}
                    rowKey="key"
                />
            </div>
        </div>

    );
};
export default Table7;